import { Link } from "react-router-dom";
import { FileText } from "lucide-react";
import PageMeta from "./PageMeta";

// The current agenda for the next upcoming meeting.
const currentAgenda = {
  label: "November 2026 Meeting Agenda",
  date: "2 November 2026",
  file: "/assets/Agenda_for_RSAA_Nov_2026_Meeting.pdf",
};

// Add previous agendas here once they are superseded by a newer one.
const archivedAgendas = [
  {
    label: "October 2026 Meeting Agenda",
    date: "5 October 2026",
    file: "/assets/Agenda_for_RSAA_Oct_2026_Meeting.pdf",
  },
  {
    label: "September 2026 Meeting Agenda",
    date: "7 September 2026",
    file: "/assets/Agenda_for_RSAA_Sept_2026_Meeting.pdf",
  },
  {
    label: "August 2026 Meeting Agenda",
    date: "1 August 2026",
    file: "/assets/Agenda_for_RSAA_Aug_2026_Meeting.pdf",
  },
  {
    label: "July 2026 Meeting Agenda",
    date: "1 July 2026",
    file: "/assets/Agenda_for_RSAA_July_2026_Meeting.pdf",
  },
  {
    label: "June 2026 Meeting Agenda",
    date: "1 June 2026",
    file: "/assets/Agenda_for_RSAA_June_2026_meeting.pdf",
  },
  {
    label: "11th May 2026 Meeting Agenda",
    date: "11 May 2026",
    file: "/assets/Agenda_for_RSAA_May_2026_Meeting.pdf",
  },
  {
    label: "13th April 2026 Meeting Agenda",
    date: "13 April 2026",
    file: "/assets/Agenda_for_RSAA_13th_April_meeting_8_4_26.pdf",
  },
];

function AgendaCard({ item, colorClass, borderHover, bgHover, badgeBorder, badgeBg, badgeText }) {
  return (
    <a
      href={item.file}
      target="_blank"
      rel="noopener noreferrer"
      className={`flex items-center gap-5 rounded-2xl border border-white/10 bg-white/5 p-5 transition ${borderHover} ${bgHover}`}
    >
      <div className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-xl ${colorClass}`}>
        <FileText className="h-6 w-6" />
      </div>
      <div className="min-w-0 flex-1">
        <p className="font-semibold text-white">{item.label}</p>
        <p className="mt-0.5 text-xs text-slate-400">{item.date}</p>
      </div>
      <span className={`shrink-0 rounded-lg border ${badgeBorder} ${badgeBg} px-3 py-1 text-xs font-medium ${badgeText}`}>
        Open PDF
      </span>
    </a>
  );
}

export default function AgendaPage() {
  return (
    <div className="page-shell min-h-screen bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 text-white">
      <PageMeta title="Meeting Agendas | Redruth Sea Angling Association" noindex />
      <div className="mx-auto max-w-4xl px-6 py-16 sm:px-8 lg:px-12">

        <div className="flex flex-wrap gap-3">
          <Link to="/" className="standalone-only inline-flex items-center gap-2 rounded-lg border border-cyan-300/40 bg-cyan-400/10 px-4 py-2 text-sm text-cyan-200 transition hover:bg-cyan-400/20">
            ← Back
          </Link>
          <Link to="/members" className="inline-flex items-center gap-2 rounded-lg border border-white/10 bg-white/5 px-4 py-2 text-sm text-slate-300 transition hover:bg-white/10">
            Members' Documents
          </Link>
        </div>

        <div className="mt-8">
          <p className="text-sm font-semibold uppercase tracking-[0.3em] text-cyan-300">Redruth Sea Angling Association</p>
          <h1 className="heading-glow mt-3 text-4xl font-bold tracking-tight text-white sm:text-5xl">Meeting Agendas</h1>
        </div>

        {/* Current Agenda */}
        <div className="mt-10">
          <h2 className="text-xl font-semibold text-amber-300 mb-4">Current and Past Meeting Agendas</h2>
          {currentAgenda ? (
            <AgendaCard
              item={currentAgenda}
              colorClass="bg-amber-400/10 text-amber-300"
              borderHover="hover:border-amber-300/30"
              bgHover="hover:bg-amber-400/5"
              badgeBorder="border-amber-300/20"
              badgeBg="bg-amber-400/10"
              badgeText="text-amber-300"
            />
          ) : (
            <p className="text-slate-400">No current agenda has been published yet.</p>
          )}
        </div>

        {/* Archived Agendas */}
        <div className="mt-12">
          <h2 className="text-xl font-semibold text-slate-300 mb-4">Archived Meeting Agendas</h2>
          {archivedAgendas.length === 0 ? (
            <p className="text-slate-400">No archived agendas yet.</p>
          ) : (
            <div className="space-y-4">
              {archivedAgendas.map((item) => (
                <AgendaCard
                  key={item.file}
                  item={item}
                  colorClass="bg-slate-400/10 text-slate-300"
                  borderHover="hover:border-slate-300/30"
                  bgHover="hover:bg-slate-400/5"
                  badgeBorder="border-slate-300/20"
                  badgeBg="bg-slate-400/10"
                  badgeText="text-slate-300"
                />
              ))}
            </div>
          )}
        </div>

      </div>
    </div>
  );
}
